import {Naja} from "naja";
import IExtension from "./IExtension";

/**
 * Animate height of the element in redrawn snippet.
 * Element must be market with attribute `data-animate-height`.
 * @example
 *  ```HTML
 *  {snippet}
 *  <div class="card-body border-top row overflow-hidden" data-animate-height>
 *      Some content with variable size
 *  </div>
 *  {snippet}
 *  ```
 * Extension expects same count of `[data-animate-height]` elements in original and fresh snippet content.
 */
export default class AnimateHeightExtension implements IExtension {

    private heights: number[] = []

    public initialize(naja: Naja): void {
        naja.snippetHandler.addEventListener('beforeUpdate', (e) => this.readHeights($(<HTMLElement>e.detail.snippet)));
        naja.snippetHandler.addEventListener('afterUpdate', (e) => this.animateHeight($(<HTMLElement>e.detail.snippet)));
    }

    /**
     * reads heights of original elements before redrawn
     */
    private readHeights($snippet: JQuery): void {
        this.heights = [];
        $snippet.find('[data-animate-height]').each((i, el) => {
           this.heights.push(el.offsetHeight);
        });
    }


    /**
     * animate fresh elements to their default size
     */
    private animateHeight($snippet: JQuery): void {
        $snippet.find('[data-animate-height]').each((i, el) => {
            const originalHeight = this.heights.shift();

            if (typeof originalHeight !== "number") {
                return;
            }

            const newHeight = el.offsetHeight;
            const $el = $(el);

            $el.css('height', originalHeight+'px');
            $el.animate(
                { height: newHeight },
                $el.data('animate-height') ?? 400,
                () => $el.css('height', ''),
            );

        });
    }

}
